"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _PageHeading = _interopRequireDefault(require("../components/PageHeading"));
var _Paragraph = _interopRequireDefault(require("../components/Paragraph"));
var _RicePaper = _interopRequireDefault(require("../components/RicePaper"));
var _useBreadcrumbs = _interopRequireDefault(require("../hooks/use-breadcrumbs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PAGE_TITLE = '403 - Forbidden';
const HttpInternalServerError = () => {
  (0, _useBreadcrumbs.default)([{
    label: 'Home',
    href: '/'
  }]);
  return /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, /*#__PURE__*/_react.default.createElement(_PageHeading.default, {
    title: PAGE_TITLE
  }), /*#__PURE__*/_react.default.createElement(_RicePaper.default, {
    sx: {
      maxWidth: 'sm',
      width: '80%',
      margin: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    translate: "no"
  }, "Jogai"), " (", /*#__PURE__*/_react.default.createElement("span", {
    lang: "ja"
  }, "\u9664\u5916"), ")\u2026you shouldn't be here."), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    paragraph: true
  }, "If you require access, please", ' ', /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: "/contact-us"
  }, "contact us"), ".")));
};
HttpInternalServerError.defaultProps = {};
var _default = exports.default = HttpInternalServerError;